<template>
  <w-flow-analysis-view ref="flowAnalysisView" :obj-type="selectedNode.subType" :flow-obj-filter="objFilter" />
</template>

<script>
import { mapGetters } from 'vuex';
import WFlowAnalysisView from '../../FlowAnalysis/components/view/FlowAnalysisView';

export default {
  name: 'WPerformanceNodeFlowAnalysis',
  components: {
    WFlowAnalysisView,
  },
  props: {
    active: Boolean,
    objFilter: Object,
  },
  computed: {
    showFlowAnalysis() {
      const objType = this.selectedNode.subType;

      return objType === 'netdevice' || objType === 'netinterface';
    },
    ...mapGetters(['analysisDateParams', 'selectedNode']),
  },
  watch: {
    analysisDateParams() {
      if (!this.showFlowAnalysis) {
        return;
      }
      this.loadData();
    },
  },
  methods: {
    loadData() {
      if (this.active) {
        this.$refs.flowAnalysisView.loadFlowChart();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/flow-analysis/index.vue